import { lazy } from 'react';

/**
 * Lazy-loaded components for code splitting
 * Each component will be loaded only when needed
 */

// Dashboard and main pages
export const Dashboard = lazy(() => import('../pages/Dashboard'));
export const MePage = lazy(() => import('../pages/Me'));

// Profile and onboarding pages
export const WorkHistoryPageV2 = lazy(() => import('../features/workExperience/pages/WorkHistoryPageV2'));
export const HighlightsPageV2Clean = lazy(() => import('../pages/Highlights/HighlightsV2Clean'));
export const SummaryAndSkillsPage = lazy(() => import('../pages/Summary & Skills/SummaryAndSkillsPage'));
export const ResumePreviewPage = lazy(() => import('../pages/Profile/ResumePreviewPageV5'));

// Application pages
export const ApplicationCatalogue = lazy(() => import('../pages/ApplicationCatalogue'));
export const ApplicationFlowPage = lazy(() => import('../features/applications/pages/ApplicationFlowPage'));
export const SkillConfigurationPage = lazy(() => import('../features/applications/pages/SkillConfigurationPage'));

// Work history pages
export const WorkHistoryPage = lazy(() => import('../pages/WorkHistory/V2/WorkHistoryPage'));
export const WorkHistoryV2 = lazy(() => import('../pages/WorkHistoryV2'));
export const WorkHistoryV3 = lazy(() => import('../pages/WorkHistoryV3'));

// Editor pages (heavy components)
export const SelectBullets = lazy(() => import('../pages/SelectBullets'));
export const CoverLetterTailor = lazy(() => import('../pages/CoverLetterTailor'));
export const TailorResumePage = lazy(() => import('../pages/TailorResumePage'));
export const SectionDragPreview = lazy(() => import('../components/SectionDragPreview'));

// Admin pages (rarely used)
// Removed AdminDashboard - now using AdminRouter directly

// Subscription and pricing
export const PricingPage = lazy(() => import('../features/Subscription/pages/PricingPage'));
export const SubscriptionPage = lazy(() => import('../features/Subscription/pages/SubscriptionPage'));

// Help and other pages
export const HelpPage = lazy(() => import('../pages/HelpPage'));
export const WorkHistoryHelp = lazy(() => import('../pages/WorkHistoryHelp'));

// Legacy work history pages
export const WorkHistoryForm = lazy(() => import('../pages/WorkHistory'));
export const Highlights = lazy(() => import('../pages/Highlights'));
export const MasterResume = lazy(() => import('../pages/MasterResume'));
export const SelectTargetRole = lazy(() => import('../pages/SelectTargetRole'));
export const OrgSnapshotFlow = lazy(() => import('../components/Work-history/OrgSnapshotFlow'));

// Profile layout
export const ProfileLayout = lazy(() => import('../components/Profile/ProfileLayout'));